/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createContext,
  PropsWithChildren,
  // useContext,
  useEffect,
  useState,
} from "react";
import websocketService from "./websocket-service";

type WebSocketState = {
  subscribeToTopic: (
    topic: string,
    topicKey: string,
    callback: (arg: any) => void
  ) => void;
  unsubscribeFromTopic: (topicKey: string) => void;
  connected: boolean;
};

const WebSocketContext = createContext<WebSocketState | null>(null);

export const WebSocketProvider = ({ children }: PropsWithChildren) => {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    websocketService.connect(() => {
      setConnected(true);
    });

    return () => {
      websocketService.disconnect(() => {
        setConnected(false);
      });
    };
  }, []);

  const subscribeToTopic = (
    topic: string,
    topicKey: string,
    callback: (message: any) => void
  ) => {
    websocketService.subscribeToTopic(topic, topicKey, (message) => {
      const parsedMessage = JSON.parse(message);
      callback(parsedMessage);
    });
  };

  const unsubscribeFromTopic = (topicKey: string) => {
    websocketService.unsubscribe(topicKey);
  };

  return (
    <WebSocketContext.Provider
      value={{ subscribeToTopic, unsubscribeFromTopic, connected }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

// export const useWebSocket = () => {
//   const context = useContext(WebSocketContext);
//   if (!context) {
//     throw new Error("useWebSocket must be used within a WebSocketProvider");
//   }
//   return context;
// };
